import { getMimeTypeFromUrl } from '#pplx/frontend/common/files/urls.js';
export function getAttachmentMediaKind(name, mimeType = '') {
    const type = mimeType && mimeType !== 'application/octet-stream' ? mimeType : getMimeTypeFromUrl(name);
    if (type.startsWith('image/'))
        return 'image';
    if (type.startsWith('video/'))
        return 'video';
    return undefined;
}
//# sourceMappingURL=attachmentMedia.js.map